export type ScriptStage = 'DEVELOPMENT' | 'SAMPLE' | 'CONTRACT' | 'RELATIONSHIP' | 'OTHER';

// Keep scene values unchanged: historical followups, script versions and APIs
// continue to use the original scene. Stages organize selection and discovery.
export const scriptStageGroups: readonly { id: ScriptStage; label: string; scenes: readonly string[] }[] = [
  { id: 'DEVELOPMENT', label: '开发', scenes: [
    '开场确认', '进门问候', '商品咨询', '客户主动询价', '起订量 MOQ 咨询',
    '客户问是否支持混批', '客户问一件代发', '客户问能不能上门看厂', '自动回复',
  ] },
  { id: 'SAMPLE', label: '样品阶段', scenes: [
    '拿样咨询', '样品跟进', '材质 / 工艺咨询', '定制 / OEM / LOGO 印刷',
  ] },
  { id: 'CONTRACT', label: '合同阶段', scenes: [
    '客户犹豫、对比别家', '讨价还价', '引导催促', '促成交易', '定金 / 付款方式',
    '交期 / 生产周期', '缺货 / 断货回复', '成交发货', '物流相关', '开票话术',
  ] },
  { id: 'RELATIONSHIP', label: '客情维护', scenes: [
    '日常回访', '新品分享', '活动通知', '老客福利', '复购提醒',
    '售后服务', '售后用语', '质量 / 次品处理', '安抚顾客', '告别用语',
  ] },
  { id: 'OTHER', label: '其他场景', scenes: ['其他'] },
];

const stageByScene = new Map(scriptStageGroups.flatMap(group => group.scenes.map(scene => [scene, group.id] as const)));

export function getScriptStage(scene: string): ScriptStage {
  return stageByScene.get(scene.trim()) ?? 'OTHER';
}

export function scenesForStage(stage: ScriptStage, extraScenes: readonly string[] = []): string[] {
  const group = scriptStageGroups.find(item => item.id === stage);
  if (!group) return [];
  return [...new Set([...group.scenes, ...extraScenes.filter(scene => scene.trim() && getScriptStage(scene) === stage)])];
}

export function scriptStageLabel(stage: ScriptStage): string {
  return scriptStageGroups.find(group => group.id === stage)?.label ?? '其他场景';
}
